import RichContentCard from "./rich-content-card";

export type { RichContentCardProps } from "./rich-content-card";

export { RichContentCard };
